var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"450px","margin-top":"10px"},attrs:{"id":_vm.divId}})
}
var staticRenderFns = []

export { render, staticRenderFns }